import React, { useEffect, useState } from 'react';
import { Redirect } from 'react-router-dom';
import Loader from '../../Restore/components/utility/loader';
import { getUserServices } from '../apis/permissions-api-new';
import {
  getRestoreAccessFromStorage,
  getRedirectForNonRestoreUser,
  userHasRestoreAccessFromServices,
} from '../utils/moduleRouting';

/**
 * Blocks /dashboard when the user has no Restore service access.
 */
export default function RestoreDashboardGuard({ children }) {
  const [state, setState] = useState({ status: 'checking', redirectTo: '/no-access' });

  useEffect(() => {
    let cancelled = false;

    const run = async () => {
      const fromStorage = getRestoreAccessFromStorage();

      if (fromStorage === true) {
        if (!cancelled) setState({ status: 'allowed' });
        return;
      }

      if (fromStorage === false) {
        if (!cancelled) {
          setState({
            status: 'redirect',
            redirectTo: getRedirectForNonRestoreUser(
              JSON.parse(localStorage.getItem('userServiceAccess') || '{}').services
            ),
          });
        }
        return;
      }

      try {
        const services = await getUserServices();
        if (cancelled) return;

        if (userHasRestoreAccessFromServices(services)) {
          setState({ status: 'allowed' });
        } else {
          setState({
            status: 'redirect',
            redirectTo: getRedirectForNonRestoreUser(services),
          });
        }
      } catch {
        if (!cancelled) {
          setState({ status: 'redirect', redirectTo: '/no-access' });
        }
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.status === 'checking') {
    return <Loader />;
  }

  if (state.status === 'redirect') {
    return <Redirect to={state.redirectTo} />;
  }

  return children;
}
